interface DepositNetworkItem {
  value: string;
  blockchainName: string;
}

interface DepositBlockchain {
  blockchainName: string;
  blockchainAsset: string;
}

/**
 * `fze_tron` and `tron` share one networkName (`Tron (TRC20)`).
 * The dropdown already drops the chain the user's regulation cannot use.
 * Match that item's blockchainName instead of the first raw row with the same networkName.
 */
export function selectDepositBlockchain<T extends DepositBlockchain>(
  blockchainInfo: T[] | undefined,
  networkItems: DepositNetworkItem[],
  currency: string,
  networkName: string | null | undefined,
): T | undefined {
  const networkItem = networkItems.find((item) => item.value === networkName);
  if (!networkItem) return undefined;
  return blockchainInfo?.find(
    (info) => info.blockchainName === networkItem.blockchainName && info.blockchainAsset === currency,
  );
}
